export const END_STATES_LIST = [
  'END_CREATE_EXPIRED',
  'END_BEFORE_ISSUED',
  'END_CANCELED',
  'END_UPLIFTED',
  'END_AMEND',
  'END_TRANSFERED',
  'END_ISSUED_EXPIRED',
  'END_PAID_DEMANDED',
  'END_PAID_WALKED',
  'END_UNI_UPLIFTED'
]

export const AU_STATES = ['NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'ACT', 'NT'] as const
